import { IngInputBase } from './ing-input-base';

export class IngChildForm extends IngInputBase<Array<any>> {
  public dataLst:    Array<any>;
  public childForm:  {
    object: any,
    params: Array<any>
  };
  public childParams: {
    fields: Array<any>,
    newItemTitle: string,
    editItemTitle: string,
    newItemText: string, 
    rowsOnPage: number, 
    sortBy: string, 
    sortOrder: string, 
    gridButtons: Array<any>, 
    onEdit: any, 
    onCreate: any, 
    onDelete: any, 
    onGridClick: any 
  };

  constructor(
    options: {
      value?: Array<any>,
      key?: string,
      label?: string,
      description?: string,
      required?: boolean,
      order?: number,
      childForm?: {
        object: any,
        params: Array<any>
      },
      childParams?: any,
      dataLst?: Array<any>,
      controlType?: string,
      placeHolder?: string,
      classContainer?: string
    } = {}
  ) {
    super(options);

    this.dataLst     = options.dataLst     || [];
    this.childParams = options.childParams || {};
    this.childForm   = options.childForm   || {
      object: {},
      params: []
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/inputs/ing-child-form.ts